import type { TitleRarity } from './profile-api';

/**
 * Which equip scene — and therefore which title "material" — each rarity group uses. Kept apart from
 * title-scenes.ts (which is lazy-loaded with its art and sounds) so the profile card can style its
 * title plate to match without pulling the scene code in. ONE table: re-map a group here.
 */
export type SceneKind = 'stamp' | 'laser' | 'holo' | 'crystal' | 'lightning';

export const SCENE_FOR_RARITY: Record<TitleRarity, SceneKind> = {
  MISSION: 'stamp',
  COMMON: 'laser',
  RARE: 'holo',
  EPIC: 'crystal',
  LEGENDARY: 'lightning',
};
